import { useEffect } from 'react';

import { API_BASE } from '../consts/endpoints';
import { useAuth } from '../context/auth';

const useCheckRedirect = () => {
    const { isLoggedIn } = useAuth();

    const checkForRedirect = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (!urlParams.has('redirect')) {
            return;
        }

        const decodedUrl = atob(urlParams.get('redirect')); // decode the base64 encoded URL
        const isFullUrl = /^(http|https):\/\/|www\./i.test(decodedUrl);

        if (!decodedUrl.startsWith('/') && isFullUrl) {
            window.location.assign(404);
            throw new Error(`Invalid redirect URL provided: ${decodedUrl}`);
        }

        try {
            const url = new URL(decodedUrl, API_BASE);
            window.location.assign(url.href);
        } catch (e) {
            window.location.assign(404);
            throw new Error(e);
        }
    };

    useEffect(() => {
        if (isLoggedIn === true) {
            checkForRedirect();
        }
    }, [isLoggedIn]);
};

export default useCheckRedirect;
